import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { NEW_WAY_TO_ENCODING_FILTER_SIGN } from "go-list/core/components/Filter/services";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { adminApi } from "../../../../../../../../services/Api/Admin/adminApi";
import PartnerForm from "../../components/PartnerForm";

const AdminPartnersNewPage = () => {
	const [customFieldsConfig, setCustomFieldsConfig] = useState<CustomFieldTemplateApi[] | undefined>(undefined);
	const { t } = useTranslation("admin");
	const { addFlash } = useFlash();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(
			`${t("modules.partner.action.add_partner.title")} | ${t("lib:go_component.navigation.admin")}`
		);
		fetchCustomFields();
	}, []);

	const fetchCustomFields = async () => {
		try {
			const params = {
				f: btoa(unescape(encodeURIComponent(`${NEW_WAY_TO_ENCODING_FILTER_SIGN}resource_type=PARTNER`))),
			};
			const res = await adminApi.getCustomFields(params);
			setCustomFieldsConfig(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!customFieldsConfig) {
		return <LoadingContainer />;
	}

	return (
		<div className="content">
			<Header title={`${t("modules.partner.action.add_partner.title")}`} />
			<PartnerForm customFieldsConfig={customFieldsConfig} />
		</div>
	);
};
export default AdminPartnersNewPage;
